export default {
  // Endpoints
  loginEndpoint: '/jwt/login',
  getClientGoogleEndpoint: '/jwt/client-google',
  loginGoogleEndpoint: '/jwt/login-google',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',
  alterarSenhaEndpoint: '/jwt/trocar-senha',
  forgotPasswordEndpoint: '/jwt/esqueci-senha',
  confirmAccessEndpoint: '/jwt/confirmar-acesso',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
